import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Trash2 } from "lucide-react";

export function NewMapDialog({ open, onOpenChange, onCreate }) {
  const [name, setName] = useState("My License Map");
  const submit = (e) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    onCreate(trimmed);
    setName("My License Map");
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="new-map-dialog">
        <form onSubmit={submit}>
          <DialogHeader>
            <DialogTitle>New Feature Map</DialogTitle>
            <DialogDescription>
              Build your own column: click cells in the new column to mark the features your organization needs, then
              compare against the suites.
            </DialogDescription>
          </DialogHeader>
          <div className="py-4">
            <Input
              autoFocus
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Map name"
              aria-label="Map name"
              data-testid="new-map-name"
            />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button type="submit" data-testid="new-map-create">
              Create
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export function LoadMapDialog({ open, onOpenChange, maps, onLoad, onDelete }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="load-map-dialog">
        <DialogHeader>
          <DialogTitle>Load Feature Map</DialogTitle>
          <DialogDescription>Saved maps are stored in this browser.</DialogDescription>
        </DialogHeader>
        <div className="max-h-[40vh] overflow-y-auto py-2">
          {maps.length === 0 && <p className="text-sm text-muted-foreground">No saved maps yet.</p>}
          <ul className="space-y-1">
            {maps.map((m) => (
              <li key={m.id || m.name} className="flex items-center justify-between gap-2 rounded-md border px-3 py-2">
                <button
                  type="button"
                  className="text-left text-sm font-medium text-[#0070f7] hover:underline"
                  onClick={() => onLoad(m)}
                  data-testid={`load-map-${m.id || m.name}`}
                >
                  {m.name}
                  <span className="ml-2 text-xs font-normal text-muted-foreground">
                    {Object.keys(m.values || {}).length} features
                  </span>
                </button>
                <Button
                  type="button"
                  variant="ghost"
                  size="icon"
                  aria-label={`Delete ${m.name}`}
                  onClick={() => onDelete(m)}
                  data-testid={`delete-map-${m.id || m.name}`}
                >
                  <Trash2 size={16} />
                </Button>
              </li>
            ))}
          </ul>
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
